import { render } from "./PDFPopUp.vue?vue&type=template&id=40b70f47&ts=true"
import script from "./PDFPopUp.vue?vue&type=script&lang=ts"
export * from "./PDFPopUp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__